import { colors } from '@dhis2/ui-constants'

export const backgroundColor = colors.white
export const borderColor = colors.grey400
export const borderRadius = '3px'
